import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ActionType } from 'typesafe-actions'
import { NAMESPACE } from '../constants'
import { TCreateSegmentRequest, TSegmentSavedPayload, TUpdateSegmentRequest } from '../types'

/**
 * Holds no data: segments live in `api.agency`, memberships in `api.user`. The
 * events exist so the create/update epics can coordinate several API calls and
 * apiState can track the whole save as one request.
 */
const bookSegmentsSlice = createSlice({
  name: NAMESPACE,
  initialState: {},
  reducers: {
    createSegment_request: (state, { payload }: PayloadAction<TCreateSegmentRequest>) => {},
    createSegment_success: (state, { payload }: PayloadAction<TSegmentSavedPayload>) => {},
    updateSegment_request: (state, { payload }: PayloadAction<TUpdateSegmentRequest>) => {},
    updateSegment_success: (state, { payload }: PayloadAction<TSegmentSavedPayload>) => {},
  },
})

/**
 * Exports
 */
const { reducer, actions: events } = bookSegmentsSlice

export type BookSegmentsEvent = ActionType<typeof events>

export { events as bookSegmentsEvents, reducer as bookSegmentsReducer }
